import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";


export default class SameHeightGridItem extends React.Component {

    static propTypes = {
        className         : PropTypes.string,
        contentClassName  : PropTypes.string
    };

    render = () => (
        <div className={classnames(this.props.className, "flex-grid__item")}>
            <div className={classnames(this.props.contentClassName, "flex-grid__item-content")}>{ this.props.children }</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/same-height-grid/SameHeightGridItem.jsx